import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const navigate = useNavigate();

    const handleNavClick = (path) => {
        navigate(path);
    };

    const handleLogoClick = () => {
        navigate('/home');
    };

    return (
        <footer className="footer">
            <div className="footer-content">
                {/* 桌面端布局 */}
                <div className="footer-desktop-layout">
                    {/* 左侧区域 */}
                    <div className="footer-left">
                        {/* 第一行：Logo + 文字 + 主导航 */}
                        <div className="footer-row-1">
                            <div className="logo-text-section" onClick={handleLogoClick}>
                                <img 
                                    src={require('../images/home/logo_g.png')} 
                                    alt="Logo" 
                                    className="footer-logo"
                                />
                                <span className="footer-brand">MARLO</span>
                            </div>
                            <nav className="footer-main-nav">
                                <span className="footer-nav-item" onClick={() => handleNavClick('/about')}>About</span>
                                <span className="footer-nav-item" onClick={() => handleNavClick('/event')}>Events</span>
                                <span className="footer-nav-item" onClick={() => handleNavClick('/business')}>For Business</span>
                            </nav>
                        </div>
                        
                        {/* 第二行：底部链接 */}
                        <div className="footer-row-2">
                            <nav className="footer-bottom-nav">
                                <span className="footer-bottom-item" onClick={() => handleNavClick('/policy')}>Privacy Policy</span>
                                <span className="footer-bottom-item" onClick={() => handleNavClick('/community')}>Community Guidelines</span>
                            </nav>
                        </div>
                    </div>

                    {/* 右侧区域 */}
                    <div className="footer-right">
                        {/* 第一行：社交媒体图标 */}
                        <div className="footer-social-row">
                            <div className="social-icons">
                                <a href="mailto:Hello@himarlo.com" className="social-icon-container">
                                    <img 
                                        src={require('../images/home/email.png')} 
                                        alt="Email" 
                                        className="social-icon default-icon"
                                    />
                                    <img 
                                        src={require('../images/home/email_b.png')} 
                                        alt="Email" 
                                        className="social-icon hover-icon"
                                    />
                                </a>
                                {/* Instagram 入口暂时隐藏，后续恢复删掉这层注释即可
                                <a href="https://www.instagram.com/himarlo_us?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-icon-container">
                                    <img 
                                        src={require('../images/home/ins.png')} 
                                        alt="Instagram" 
                                        className="social-icon default-icon"
                                    />
                                    <img 
                                        src={require('../images/home/ins_b.png')} 
                                        alt="Instagram" 
                                        className="social-icon hover-icon"
                                    />
                                </a>
                                */}
                                                                <a href="https://apps.apple.com/us/app/marlo-social/id6450737280" target="_blank" rel="noopener noreferrer" className="social-icon-container">
                                    <img 
                                        src={require('../images/home/store.png')} 
                                        alt="Store" 
                                        className="social-icon default-icon"
                                    />
                                    <img 
                                        src={require('../images/home/store_b.png')} 
                                        alt="Store" 
                                        className="social-icon hover-icon"
                                    />
                                </a>
                            </div>
                        </div>
                        
                        {/* 第二行：版权信息 */}
                        <div className="footer-copyright-row">
                            <span className="footer-copyright">© 2026 Projectdotfus LLC. All rights reserved.</span>
                        </div>
                    </div>
                </div>

                {/* H5移动端布局 */}
                <div className="footer-mobile-layout">
                    {/* 第一行：Logo + 文字 + 主导航 */}
                    <div className="footer-row-1">
                        <div className="logo-text-section" onClick={handleLogoClick}>
                            <img 
                                src={require('../images/home/logo_g.png')} 
                                alt="Logo" 
                                className="footer-logo"
                            />
                            <span className="footer-brand">MARLO</span>
                        </div>
                        <nav className="footer-main-nav">
                            <span className="footer-nav-item" onClick={() => handleNavClick('/about')}>About</span>
                            <span className="footer-nav-item" onClick={() => handleNavClick('/event')}>Events</span>
                            <span className="footer-nav-item" onClick={() => handleNavClick('/business')}>For Business</span>
                        </nav>
                    </div>

                    {/* 第二行：社交媒体图标 */}
                    <div className="footer-social-row">
                        <div className="social-icons">
                            <a href="mailto:Hello@himarlo.com" className="social-icon-container">
                                <img 
                                    src={require('../images/home/email.png')} 
                                    alt="Email" 
                                    className="social-icon default-icon"
                                />
                                <img 
                                    src={require('../images/home/email_b.png')} 
                                    alt="Email" 
                                    className="social-icon hover-icon"
                                />
                            </a>
                            {/* Instagram 入口暂时隐藏，后续恢复删掉这层注释即可
                            <a href="https://www.instagram.com/himarlo_us?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-icon-container">
                                <img 
                                    src={require('../images/home/ins.png')} 
                                    alt="Instagram" 
                                    className="social-icon default-icon"
                                />
                                <img 
                                    src={require('../images/home/ins_b.png')} 
                                    alt="Instagram" 
                                    className="social-icon hover-icon"
                                />
                            </a>
                            */}
                            <a href="https://apps.apple.com/us/app/marlo-social/id6450737280" target="_blank" rel="noopener noreferrer" className="social-icon-container">
                                <img 
                                    src={require('../images/home/store.png')} 
                                    alt="Store" 
                                    className="social-icon default-icon"
                                />
                                <img 
                                    src={require('../images/home/store_b.png')} 
                                    alt="Store" 
                                    className="social-icon hover-icon"
                                />
                            </a>
                        </div>
                    </div>

                    {/* 第三行：底部链接 */}
                    <div className="footer-row-2">
                        <nav className="footer-bottom-nav">
                            <span className="footer-bottom-item" onClick={() => handleNavClick('/policy')}>Privacy Policy</span>
                            <span className="footer-bottom-item" onClick={() => handleNavClick('/community')}>Community Guidelines</span>
                        </nav>
                    </div>

                    {/* 第四行：版权信息 */}
                    <div className="footer-copyright-row">
                        <span className="footer-copyright">© 2026 Projectdotfus LLC. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
